const handler = ( $ ) => {
	// Find all menu items with children
	const $menuItemsWithChildren = $( 'header .menu-item-has-children' );
	const $overlay = $( '.site-overlay' );
	const $hamburger = $( '.header__burger' );
	const $mobileMenu = $( '.mobile-menu' );
	const $mobileMenuClose = $( '.mobile-menu__close' );
	const $searchButton = $( '.header__top-search button' );
	const $searchModal = $( '.search-modal' );
	const $body = $( 'body' );

	// Search modal state
	const searchModalOpen = false;

	// Mobile menu toggle
	$hamburger.on( 'click', function () {
		// If GTranslate popup is open, close it first and DO NOT toggle the menu on this click
		const $gtPopup = $( '.gt_white_content' );
		const $gtOverlay = $( '.gt_black_overlay' );
		const wasPopupVisible = $gtPopup.is( ':visible' );

		if ( wasPopupVisible ) {
			// Close popup similarly to language_switcher.js close routine
			$gtOverlay.trigger( 'click' );
			$gtPopup.add( $gtOverlay ).each( function () {
				$( this ).css( 'display', 'none' );
			} );
			$body.removeClass( 'freeze' );
			$( document ).trigger( 'gtranslate_wrapper:close' );

			// Ensure burger is not active and mobile menu is closed, then exit early
			$hamburger.removeClass( 'active' );
			$mobileMenu.removeClass( 'active' );
			$body.removeClass( 'mobile-menu-open' );
			setTimeout( function () {
				if ( ! $mobileMenu.hasClass( 'active' ) ) {
					$mobileMenu.css( 'display', 'none' );
				}
			}, 300 );
			return;
		}

		// Normal toggle flow when popup is not visible
		$( this ).toggleClass( 'active' );
		$mobileMenu.css( 'display', 'block' );

		// Use setTimeout with 0ms to ensure display:block is applied before adding active class
		setTimeout( function () {
			$mobileMenu.toggleClass( 'active' );
			$body.toggleClass( 'mobile-menu-open' );
		}, 0 );
	} );

	// Mobile menu close button
	$mobileMenuClose.on( 'click', function () {
		$hamburger.removeClass( 'active' );
		$mobileMenu.removeClass( 'active' );
		$body.removeClass( 'mobile-menu-open' );

		// Hide mobile menu after transition
		setTimeout( function () {
			if ( ! $mobileMenu.hasClass( 'active' ) ) {
				$mobileMenu.css( 'display', 'none' );
			}
		}, 300 ); // Match transition duration
	} );

	// Mobile menu items with children
	const $mobileMenuItemsWithChildren = $(
		'.mobile-menu .menu-item-has-children'
	);

	$mobileMenuItemsWithChildren.each( function () {
		const $menuItem = $( this );
		const $submenu = $menuItem.children( '.sub-menu' );
		const $link = $menuItem.children( 'a' );

		$link.on( 'click', function ( e ) {
			e.preventDefault();
			e.stopPropagation();

			// Close other open submenus
			if ( ! $menuItem.hasClass( 'submenu-open' ) ) {
				$mobileMenuItemsWithChildren
					.not( $menuItem )
					.removeClass( 'submenu-open' )
					.children( '.sub-menu' )
					.slideUp( 300 );
			}

			$menuItem.toggleClass( 'submenu-open' );

			if ( $menuItem.hasClass( 'submenu-open' ) ) {
				$submenu.slideDown( 300 );
			} else {
				$submenu.slideUp( 300 );
			}
		} );
	} );

	// Add click event to menu items with children (desktop)
	$menuItemsWithChildren.each( function () {
		const $menuItem = $( this );
		const $submenuContainer = $menuItem.children( '.submenu-container' );

		// Add click event to the menu item
		$menuItem.on( 'click', function ( e ) {
			// Only trigger if clicking on the menu item itself or its direct link
			if (
				$( e.target ).is( $menuItem ) ||
				$( e.target ).is( $menuItem.children( 'a' ) )
			) {
				e.preventDefault();
				e.stopPropagation();

				// Close other open submenus
				$menuItemsWithChildren
					.not( $menuItem )
					.removeClass( 'submenu-open' );
				$menuItemsWithChildren
					.not( $menuItem )
					.children( '.submenu-container' )
					.animate( { opacity: 0 }, 210, function () {
						$( this ).hide().css( 'left', '' );
					} );

				// Toggle current submenu
				$menuItem.toggleClass( 'submenu-open' );

				if ( $menuItem.hasClass( 'submenu-open' ) ) {
					$submenuContainer.css( {
						opacity: 0,
						display: 'flex',
						left: '',
					} );

					const windowWidth = $( window ).width();
					const rect = $submenuContainer[ 0 ].getBoundingClientRect();

					if ( rect.right > windowWidth ) {
						const overflow = rect.right - windowWidth;
						const currentLeft = $submenuContainer.position().left;
						$submenuContainer.css(
							'left',
							currentLeft - overflow - 20 + 'px'
						);
					}

					$submenuContainer.animate( { opacity: 1 }, 210 );
				} else {
					$submenuContainer.animate(
						{ opacity: 0 },
						210,
						function () {
							$( this ).hide().css( 'left', '' );
						}
					);
					$overlay.fadeOut( 210 );
				}
			}
		} );
	} );

	// Close submenu when clicking outside
	$( document ).on( 'click', function ( e ) {
		if ( ! $( e.target ).closest( '.menu-item-has-children' ).length ) {
			$menuItemsWithChildren.removeClass( 'submenu-open' );

			// Handle desktop menu items (with opacity animation)
			$menuItemsWithChildren
				.not( '.mobile-menu .menu-item-has-children' )
				.children( '.submenu-container' )
				.animate( { opacity: 0 }, 210, function () {
					$( this ).hide().css( 'left', '' );
				} );

			// Handle mobile menu items (without opacity animation)
			$( '.mobile-menu .menu-item-has-children' )
				.children( '.sub-menu' )
				.slideUp( 300 );

			$overlay.fadeOut( 210 );
		}
	} );

	// Close submenu when clicking on overlay
	$overlay.on( 'click', function () {
		$menuItemsWithChildren.removeClass( 'submenu-open' );

		// Handle desktop menu items (with opacity animation)
		$menuItemsWithChildren
			.not( '.mobile-menu .menu-item-has-children' )
			.children( '.submenu-container' )
			.animate( { opacity: 0 }, 210, function () {
				$( this ).hide().css( 'left', '' );
			} );

		// Handle mobile menu items (without opacity animation)
		$( '.mobile-menu .menu-item-has-children' )
			.children( '.sub-menu' )
			.slideUp( 300 );

		$overlay.fadeOut( 210 );
	} );

	// Close submenu on ESC key
	$( document ).on( 'keydown', function ( e ) {
		if ( e.key === 'Escape' ) {
			$menuItemsWithChildren.removeClass( 'submenu-open' );

			// Handle desktop menu items (with opacity animation)
			$menuItemsWithChildren
				.not( '.mobile-menu .menu-item-has-children' )
				.children( '.submenu-container' )
				.animate( { opacity: 0 }, 210, function () {
					$( this ).hide().css( 'left', '' );
				} );

			// Handle mobile menu items (without opacity animation)
			$( '.mobile-menu .menu-item-has-children' )
				.children( '.sub-menu' )
				.slideUp( 300 );

			$overlay.fadeOut( 210 );
		}
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
